import { useState } from 'react';
import PropTypes from 'prop-types';
import CloseIcon from '../../../assets/icons/close.svg?react';
const UserDeleteModal = ({ user, onClose, onConfirm }) => {
  if (!user) return null;
  const [isPending, setIsPending] = useState(false);
  const handleConfirm = async () => {
    setIsPending(true);
    try {
      await onConfirm();
    } catch (error) {
      console.error('삭제 실패:', error);
    } finally {
      setIsPending(false);
    }
  };
  return (
    <div className="modal-background" onClick={onClose}>
      <div className="modal-container" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h3 className="text-h3 text-gray-900">사용자 삭제</h3>
          <button 
            className="close-btn"
            onClick={onClose}
          >
            <CloseIcon />
          </button>
        </div>
        <div className="modal-content">
          <table className="gray-table mt-10">
            <tr>
              <th>이메일</th>
              <td>{user.email}</td>
            </tr>
            <tr>
              <th>역할</th>
              <td>
                {user.roles.map((role, idx) => (
                  <span key={idx} className="badge badge-gray">{role}</span>
                ))}
              </td>
            </tr>
          </table>
        </div>

        <div className="modal-footer">
          <button className="btn py-5 px-10 big-btn btn-primary flex-1" onClick={handleConfirm} disabled={isPending}>
            {isPending ? '삭제 중...' : '삭제하기'}
          </button>
        </div>
      </div>
    </div>
  );
};

UserDeleteModal.propTypes = {
  user: PropTypes.shape({
    id: PropTypes.number.isRequired,
    email: PropTypes.string.isRequired,
    roles: PropTypes.arrayOf(PropTypes.string).isRequired,
  }),
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
};

export default UserDeleteModal;
